import { render, staticRenderFns } from "./carBook.vue?vue&type=template&id=83be6374"
import script from "./carBook.vue?vue&type=script&lang=js"
export * from "./carBook.vue?vue&type=script&lang=js"
import style0 from "./carBook.vue?vue&type=style&index=0&id=83be6374&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports